import CaicCarNoKeyboard from './src/CaicCarNoKeyboard.vue'
const CarNoKeyboard = {
  install: function (Vue) {
    Vue.component(CaicCarNoKeyboard.name, CaicCarNoKeyboard)
  }
}
export default CarNoKeyboard



// WEBPACK FOOTER //
// ./src/car-number-keyboard/index.js